// Shared Campaign Utilities
// Common methods used across multiple campaign components

export const CampaignUtils = {
  // Get campaign ID from URL
  getCampaignId() {
    const urlParts = window.location.pathname.split('/');
    return urlParts[urlParts.length - 2];
  },

  // Get show ID from URL
  getShowId() {
    const urlParts = window.location.pathname.split('/');
    return urlParts[urlParts.length - 4];
  },

  // Get tactic ID from URL
  getTacticId() {
    const urlParts = window.location.pathname.split('/');
    return urlParts[urlParts.length - 1];
  },

  // Get CSRF token
  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
  },

  // Handle file upload
  handleFileUpload(event) {
    const file = event.target.files[0];
    if (file) {
      return file;
    }
    return null;
  },

  // Get assets data for submission
  getAssetsData(assets) {
    return assets.map(asset => ({
      asset_type: asset.asset_type,
      file_name: asset.file_name,
      file_size: asset.file_size,
      file_type: asset.file_type,
      description: asset.description
    }));
  },

  // Check if all tactics are complete
  allTacticsComplete(tactics) {
    return tactics.every(tactic => tactic.tactic_status === 'complete');
  },

  // Toggle asset card visibility
  toggleAssetCard(tacticId) {
    const formElement = document.getElementById(`asset-form-${tacticId}`);
    if (formElement) {
      formElement.classList.toggle('hidden');
    }
  }
};
